<script setup lang="ts">
import { computed } from 'vue';
import useLocale from '../../../composables/useLocale';
import { SearchFilter, FilterOption } from '../../../search-panel-types';
import FilterChip from './FilterChip.vue';

const { t } = useLocale();

const emit = defineEmits<{ (e: 'filters-updated', filter: SearchFilter): void }>();

type Props = {
  filterKey: string;
  items: FilterOption[];
  selected: { value: SearchFilter };
  label: string;
};

const props = defineProps<Props>();

const removeFilter = () => {
  emit('filters-updated', { [props.filterKey]: [] });
};

const updateFilter = () => {
  emit('filters-updated', {
    [props.filterKey]: [{ value: 'true', label: t(`${props.label}`), count: 1 }],
  });
};

// TODO: was there a reason for this not to have a strict match?

const contentOption = computed(() => props.items.find((i) => i.value == '1'));

const isSelected = computed(() => {
  if (!props.selected.value[props.filterKey]) {
    return false;
  }
  // TODO: was there a reason for this not to have a strict match?
  return !!props.selected.value[props.filterKey].find((i) => i.value === 'true');
});
</script>

<template>
  <FilterChip
    v-if="contentOption && contentOption.count > 0"
    class="mb-0"
    :is-selected="isSelected"
    :label="t(`${props.label}`)"
    :count="contentOption.count"
    @click:close="removeFilter"
    @click="updateFilter"
    :data-testid="props.label"
  />
</template>

<style scoped></style>
